module.exports = __webpack_public_path__ + "static/media/AngularJS-large.c43d7df1.svg";